import gql from 'graphql-tag';

export const CREATE_BANK = gql`
  mutation createBankAccount($createBankAccountInput: CreateBankAccountInput!) {
    createBankAccount(createBankAccountInput: $createBankAccountInput) {
      id
      bankName
      branchId
      accountNumber
      accountType
      currency
      openingBalance
    }
  }
`;

export const CREATE_CREDIT_CARD = gql`
  mutation createCreditCard($createCreditCardInput: CreateCreditCardInput!) {
    createCreditCard(createCreditCardInput: $createCreditCardInput) {
      id
      cardName
      cardNumberMasked
      issuer
      branchId
      creditLimit
      currentBalance
      currency
      expiryDate
    }
  }
`;

export const UPDATE_BANK = gql`
  mutation updateBankAccount(
    $updateBankAccountInput: UpdateBankAccountInput!
    $id: Int!
  ) {
    updateBankAccount(
      updateBankAccountInput: $updateBankAccountInput
      id: $id
    ) {
      id
      bankName
      branchId
      accountNumber
      accountType
      currency
      openingBalance
    }
  }
`;

export const UPDATE_CREDIT_CARD = gql`
  mutation updateCreditCard(
    $updateCreditCardInput: UpdateCreditCardInput!
    $id: Int!
  ) {
    updateCreditCard(updateCreditCardInput: $updateCreditCardInput, id: $id) {
      id
      cardName
      cardNumberMasked
      issuer
      branchId
      creditLimit
      currentBalance
      currency
      expiryDate
    }
  }
`;

export const BULK_UPLOAD_BANK_TRANSACTIONS = gql`
  mutation bulkCreateStatements($file: Upload!, $offsetAccountId: Int!) {
    bulkCreateStatements(file: $file, offsetAccountId: $offsetAccountId)
  }
`;

export const MATCH_OR_UNMATCH_STATEMENT = gql`
  mutation matchOrUnmatchStatementToTransactions(
    $statusType: String!
    $statementId: Int!
    $transactionIds: [Int]
  ) {
    matchOrUnmatchStatementToTransactions(
      statusType: $statusType
      statementId: $statementId
      transactionIds: $transactionIds
    )
  }
`;

export const CREATE_TRANSACTION = gql`
  mutation createBankTransaction(
    $createBankTransactionInput: CreateBankTransactionInput!
  ) {
    createBankTransaction(
      createBankTransactionInput: $createBankTransactionInput
    ) {
      id
      bankAccountId
      transactionType
      amount
      transactionDate
      description
      refType
      refId
      referenceNumber
      transactionCategory
      reconciled
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const CATEGORIZE_TRANSACTION = gql`
  mutation categorizeTransactions(
    $statusType: String!
    $statementId: Int!
    $transactionId: Int
    $createTransactionInput: CreateBankTransactionInput
  ) {
    categorizeTransactions(
      statusType: $statusType
      statementId: $statementId
      transactionId: $transactionId
      createTransactionInput: $createTransactionInput
    )
  }
`;

export const UPDATE_TRANSACTION = gql`
  mutation updateBankTransaction(
    $id: Int!
    $updateBankTransactionInput: UpdateBankTransactionInput!
  ) {
    updateBankTransaction(
      id: $id
      updateBankTransactionInput: $updateBankTransactionInput
    ) {
      id
      bankAccountId
      transactionType
      amount
      transactionDate
      description
      refType
      referenceNumber
      transactionCategory
      paidVia
      reconciled
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const REMOVE_BANK_TRANSACTION = gql`
  mutation removeBankTransaction($id: Int!) {
    removeBankTransaction(id: $id)
  }
`;

